import React, { createContext, useRef, useContext } from "react";
import LocalizationSection from "./Header/LocalizationSection";

// Create a Context
const LocalizationContext = createContext();

// Provide the Context
export const LocalizationProvider = ({ children }) => {
  const localizationRef = useRef(null);

  return (
    <LocalizationContext.Provider value={localizationRef}>
      <div>
        {/* Render LocalizationSection and pass the ref */}
        <LocalizationSection ref={localizationRef} />
        {children}
      </div>
    </LocalizationContext.Provider>
  );
};

// Hook to Use the Localization Context
export const useLocalization = () => useContext(LocalizationContext);